import axios from 'axios';

const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '/api',
    headers: {
        // Sen Content-Type fixo: axios pon application/json nos obxectos
        // e o navegador pon multipart/form-data (+ boundary) en FormData.
        Accept: 'application/json',
    },
});

// Interceptor para agregar el token
api.interceptors.request.use(config => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
        // Evitar application/json: o navegador debe poñer multipart + boundary.
        const headers = config.headers as {
            set?: (key: string, value: string) => void;
            delete?: (key: string) => void;
            setContentType?: (value: string | false) => void;
            [key: string]: unknown;
        };
        if (typeof headers?.setContentType === 'function') {
            headers.setContentType(false);
        }
        if (typeof headers?.delete === 'function') {
            headers.delete('Content-Type');
            headers.delete('content-type');
        } else if (headers) {
            headers['Content-Type'] = undefined;
            headers['content-type'] = undefined;
        }
    }
    return config;
});

import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

// ... (existing code)

// Interceptor para manejar errores (401, 500)
api.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                // Limpiar almacenamiento y redirigir
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_user');
                window.location.href = '/login';
            } else if (error.response.status === 403) {
                Toastify({
                    text: "⛔ Acceso Denegado: " + (error.response.data.message || 'No tienes permisos'),
                    duration: 4000,
                    gravity: "top",
                    position: "right",
                    style: { background: "#dc3545" } // Danger color
                }).showToast();
            } else if (error.response.status >= 500) {
                // Alerta Visual Roja para errores de servidor
                Toastify({
                    text: "🔥 Error de servidor. El fallo ha sido registrado para revisión técnica.",
                    duration: 5000,
                    gravity: "top",
                    position: "right",
                    style: {
                        background: "linear-gradient(to right, #ff5f6d, #ffc371)",
                    }
                }).showToast();
            } else {
                // Otros errores (400, etc)
                Toastify({
                    text: "⚠️ Atención: " + (error.response.data.message || error.message),
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    style: { background: "#ffc107", color: "#333" } // Warning color
                }).showToast();
            }
        }
        return Promise.reject(error);
    }
);

export default api;
